const JSON_MIME_TYPES = ['application/json', 'application/problem+json'];
export class RetryError extends Error {
}
const setResponseBody = (response, value) => {
    Object.defineProperty(response, 'body', {
        value,
        enumerable: true,
    });
};
const responseParsers = {
    text: (response) => {
        return response.text().then((text) => {
            setResponseBody(response, text);
            return Promise.resolve(response);
        });
    },
    blob: (response) => {
        return response.blob().then((blob) => {
            setResponseBody(response, blob);
            return Promise.resolve(response);
        });
    },
    arrayBuffer: (response) => {
        return response.arrayBuffer().then((buffer) => {
            setResponseBody(response, buffer);
            return Promise.resolve(response);
        });
    },
    formData: (response) => {
        return response.formData().then((data) => {
            setResponseBody(response, data);
            return Promise.resolve(response);
        });
    },
    rawStream: (response) => {
        return Promise.resolve(response).then((data) => {
            setResponseBody(response, data.body);
            return Promise.resolve(response);
        });
    },
    buffer: (response) => {
        const formatResolver = 'buffer' in response ? response.buffer() : response.arrayBuffer();
        return formatResolver.then((data) => {
            setResponseBody(response, data);
            return Promise.resolve(response);
        });
    },
    json: (response) => {
        var contentType = response.headers.get('content-type') || '';
        return response
            .text()
            .then(function (text) {
            return text &&
                text.length &&
                JSON_MIME_TYPES.some(mimeType => contentType.includes(mimeType))
                ? JSON.parse(text)
                : text;
        })
            .then(function (parsedBody) {
            setResponseBody(response, parsedBody);
            return Promise.resolve(response);
        });
    },
};
export default responseParsers;
//# sourceMappingURL=responseParsers.js.map